module.exports = __webpack_public_path__ + "img/2013-1.f69af17c.jpeg";